import { render, staticRenderFns } from "./NumberInput.vue?vue&type=template&id=8bc61a94&scoped=true&"
import script from "./NumberInput.vue?vue&type=script&lang=ts&"
export * from "./NumberInput.vue?vue&type=script&lang=ts&"
import style0 from "./NumberInput.vue?vue&type=style&index=0&id=8bc61a94&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8bc61a94",
  null
  
)

export default component.exports